"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFattenCurve = exports.find_offcurve = exports.divide_curve = void 0;
var util_1 = require("./util");
function divide_curve(x1, y1, sx1, sy1, x2, y2, curve) {
    var rate = 0.5;
    var cut = Math.floor(curve.length * rate);
    var cut_rate = cut / curve.length;
    var tx1 = x1 + (sx1 - x1) * cut_rate;
    var ty1 = y1 + (sy1 - y1) * cut_rate;
    var tx2 = sx1 + (x2 - sx1) * cut_rate;
    var ty2 = sy1 + (y2 - sy1) * cut_rate;
    var tx3 = tx1 + (tx2 - tx1) * cut_rate;
    var ty3 = ty1 + (ty2 - ty1) * cut_rate;
    // must think about 0 : <0
    return {
        index: cut,
        off: [[x1, y1, tx1, ty1, tx3, ty3], [tx3, ty3, tx2, ty2, x2, y2]],
    };
}
exports.divide_curve = divide_curve;
// ------------------------------------------------------------------
function find_offcurve(curve, sx, sy) {
    var _a = curve[0], nx1 = _a[0], ny1 = _a[1];
    var _b = curve[curve.length - 1], nx2 = _b[0], ny2 = _b[1];
    var area = 8;
    var minx = util_1.ternarySearchMin(function (tx) { return curve.reduce(function (diff, p, i) {
        var t = i / (curve.length - 1);
        var x = util_1.quadraticBezier(nx1, tx, nx2, t);
        return diff + Math.pow((p[0] - x), 2);
    }, 0); }, sx - area, sx + area);
    var miny = util_1.ternarySearchMin(function (ty) { return curve.reduce(function (diff, p, i) {
        var t = i / (curve.length - 1);
        var y = util_1.quadraticBezier(ny1, ty, ny2, t);
        return diff + Math.pow((p[1] - y), 2);
    }, 0); }, sy - area, sy + area);
    return [nx1, ny1, minx, miny, nx2, ny2];
}
exports.find_offcurve = find_offcurve;
// ------------------------------------------------------------------
function generateFattenCurve(x1, y1, sx1, sy1, sx2, sy2, x2, y2, kRate, widthFunc, normalize_) {
    if (normalize_ === void 0) { normalize_ = util_1.normalize; }
    var curve = { left: [], right: [] };
    var isQuadratic = sx1 === sx2 && sy1 === sy2;
    var xFunc, yFunc, ixFunc, iyFunc;
    if (isQuadratic) {
        // Spline
        xFunc = function (t) { return util_1.quadraticBezier(x1, sx1, x2, t); };
        yFunc = function (t) { return util_1.quadraticBezier(y1, sy1, y2, t); };
        ixFunc = function (t) { return util_1.quadraticBezierDeriv(x1, sx1, x2, t); };
        iyFunc = function (t) { return util_1.quadraticBezierDeriv(y1, sy1, y2, t); };
    }
    else { // Bezier
        xFunc = function (t) { return util_1.cubicBezier(x1, sx1, sx2, x2, t); };
        yFunc = function (t) { return util_1.cubicBezier(y1, sy1, sy2, y2, t); };
        ixFunc = function (t) { return util_1.cubicBezierDeriv(x1, sx1, sx2, x2, t); };
        iyFunc = function (t) { return util_1.cubicBezierDeriv(y1, sy1, sy2, y2, t); };
    }
    for (var tt = 0; tt <= 1000; tt += kRate) {
        var t = tt / 1000;
        // calculate a dot
        var x = xFunc(t);
        var y = yFunc(t);
        // KATAMUKI of vector by BIBUN
        var ix = ixFunc(t);
        var iy = iyFunc(t);
        var width = widthFunc(t);
        // line SUICHOKU by vector
        var _a = normalize_([-iy, ix], width), ia = _a[0], ib = _a[1];
        curve.left.push([x - ia, y - ib]);
        curve.right.push([x + ia, y + ib]);
    }
    return curve;
}
exports.generateFattenCurve = generateFattenCurve;
